import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerReducer } from '../reducers';

export const selectCustomerFeature = createFeatureSelector<CustomerReducer.CustomerState>(CustomerReducer.featureName);

export const selectCustomer = createSelector(selectCustomerFeature, (state: CustomerReducer.CustomerState) => state.item);
